import { useParams } from "react-router-dom";
import Navbar from "../../components/Header";
import Footer from "../../components/Footer";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const PostPage = () => {
  const { postId } = useParams();

  let post = {
    id: postId,
    title: "Post Not Found",
    author: "Unknown",
    authorUrl: "/octant.png",
    date: "Unknown",
    image: "/not-found.jpg",
    content: `
# Post Not Found

Sorry, the post you are looking for does not exist.

Please check the URL or return to the [home page](/).
    `
  };

  if (postId === "1") {
    post = {
      id: postId,
      title: "Octant Security Incident",
      author: "Octant",
      authorUrl: "/octant.png",
      date: "May 6, 2025",
      image: "https://i.imgur.com/fRbZJhC.png",
      content: `
On May 6 2025, Octant's original domain, octant.sh, was compromised. The domain was managed through a Cloudflare account belonging to a former associate who was previously involved with Octant. After the hijack, the domain was modified to falsely claim that Octant had shut down and all customer data had been breached. These claims are both false.

We have since moved to our new domain, octant.gg, and all official Octant services have been moved there. No user data was accessed or compromised during this incident.

## Timeline
- **Prior to May 6, 2025**: The octant.sh domain remained linked to a Cloudflare account belonging to a former associate.
- **May 6, 2025**: The domain was hijacked. The site was replaced with false statements alleging that Octant was a scam and had suffered a data breach.
- **May 6, 2025 (continued)**: Temporary access was regained and the malicious content removed. However, control of the domain was again lost soon after.
- **May 7, 2025**: We acquiried and moved to octant.gg, updated all customer-facing links.
- **Now**: We are working to ensure that all Octant services remain secure and that this incident does not happen again. We are also working to remove the malicious content from the octant.sh domain.

## Root Cause
The octant.sh domain remained in the control of a third-party Cloudflare account that we did not revoke access from after the associate was no longer involved with Octant. This oversight led to the hijacking of the domain and its DNS.

## Resolution
- We quickly moved our operations to octant.gg, which is fully owned and operated by the current Octant team
- Control of all services and backend systems was never compromised - only the domain itself
- We've implimented stricter controls over who has access to what moving forward

## Security & Customer Data
**There has been no data breach.**\n
All servers, customer files, billing data, and account information remain secure. The claims made on octant.sh are false and should be disregarded entirely.

## Next Steps
- The incident is being monitored and reported to the relevant domain registars and hosts
- We've submitted reports to Cloudflare and search engines regarding the hijacked domain content

## Final Notes
We take security very seriously and we understand that this situation may raise concerns. We're committed to being open and transparent regarding Octant's security - our support team is available if you have any questions or want to verify anything.
Please keep in mind that octant.gg is the **only** official domain for Octant. Any other domains or sites claiming to be affiliated with Octant are **not** legitimate and should be **reported to us immediately**.

Thank you for taking the time to read this and placing your trust in us.

- The Octant Team
      `
    };
  }

  return (
    <div className="min-h-screen">
      <div className="max-w-6xl mx-auto">
        <Navbar />

        <div className="py-8 px-6 pt-24">
          <div className="mb-8">
            <img
              src={post.image}
              alt={post.title}
              className="w-full object-cover rounded-lg mb-6"
            />
          <h3 className="text-white text-3xl font-medium mb-2">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{post.title}</ReactMarkdown>
          </h3>
            <div className="flex items-center text-md">
              <img src={post.authorUrl} alt={post.author} className="h-6 w-6 rounded-full mr-1" />
              <span className="text-gray-300 ml-1">{post.author}</span>
              <span className="text-gray-500 mx-2">|</span>
              <span className="text-gray-300">{post.date}</span>
            </div>
          </div>

          <div className="prose prose-invert max-w-none text-gray-400 markdown-content">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {post.content}
            </ReactMarkdown>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default PostPage;
